import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "ea219d1c-3bd8-4ae7-a528-c11534f1c415"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterEa219d1c3bd84ae7A528C11534f1c415(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterEa219d1c3bd84ae7A528C11534f1c415 footer`}>
      {props["links"] || <Navigation className="Links3929001d5db84a3b86415ac8ff2beda9" parentTag={buildClassName("Links3929001d5db84a3b86415ac8ff2beda9", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo3e7d55e036274033A8a06b4e79709165" parentTag={buildClassName("Logo3e7d55e036274033A8a06b4e79709165", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightB556e1dfC52e432c9325Bcc53a90fdb7" parentTag={buildClassName("CopyrightB556e1dfC52e432c9325Bcc53a90fdb7", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="GroupflowF4a1fbb8C0cc4bb2A07eB60ea66a612b" parentTag={buildClassName("GroupflowF4a1fbb8C0cc4bb2A07eB60ea66a612b", parentTag)} {...props} />}
    </footer>
  );
}

// id: "3e7d55e0-3627-4033-a8a0-6b4e79709165"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "ea219d1c-3bd8-4ae7-a528-c11534f1c415"
export function Logo3e7d55e036274033A8a06b4e79709165(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo3e7d55e036274033A8a06b4e79709165" parentTag={buildClassName("Logo3e7d55e036274033A8a06b4e79709165", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "b556e1df-c52e-432c-9325-bcc53a90fdb7"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "ea219d1c-3bd8-4ae7-a528-c11534f1c415"
export function CopyrightB556e1dfC52e432c9325Bcc53a90fdb7(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightB556e1dfC52e432c9325Bcc53a90fdb7" parentTag={buildClassName("CopyrightB556e1dfC52e432c9325Bcc53a90fdb7", parentTag)} {...props} />
  );
}

// id: "3929001d-5db8-4a3b-8641-5ac8ff2beda9"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "ea219d1c-3bd8-4ae7-a528-c11534f1c415"
export function Links3929001d5db84a3b86415ac8ff2beda9(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links3929001d5db84a3b86415ac8ff2beda9" parentTag={buildClassName("Links3929001d5db84a3b86415ac8ff2beda9", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "f4a1fbb8-c0cc-4bb2-a07e-b60ea66a612b"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "ea219d1c-3bd8-4ae7-a528-c11534f1c415"
export function GroupflowF4a1fbb8C0cc4bb2A07eB60ea66a612b(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowF4a1fbb8C0cc4bb2A07eB60ea66a612b" parentTag={buildClassName("GroupflowF4a1fbb8C0cc4bb2A07eB60ea66a612b", parentTag)} {...props} />
  );
}

// id: "986f72af-fa6c-4b7f-a901-285430f1916c"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "3e7d55e0-3627-4033-a8a0-6b4e79709165"
export const LogoType986f72afFa6c4b7fA901285430f1916c = "FOOTER";

// id: "6b3387b8-2273-40c6-8c5b-f34174e6291b"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "3929001d-5db8-4a3b-8641-5ac8ff2beda9"
export const NavMenuSlug6b3387b8227340c68c5bF34174e6291b = "footer-nav";

// id: "76592845-8d0d-4034-b7c4-f5a2f0eda6c1"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "3e7d55e0-3627-4033-a8a0-6b4e79709165"
export const ContentSlug765928458d0d4034B7c4F5a2f0eda6c1 = "footer-logo";

const Components = {
  DefaultFooterEa219d1c3bd84ae7A528C11534f1c415,
  Logo3e7d55e036274033A8a06b4e79709165,
  CopyrightB556e1dfC52e432c9325Bcc53a90fdb7,
  Links3929001d5db84a3b86415ac8ff2beda9,
  GroupflowF4a1fbb8C0cc4bb2A07eB60ea66a612b,
  LogoType986f72afFa6c4b7fA901285430f1916c,
  NavMenuSlug6b3387b8227340c68c5bF34174e6291b,
  ContentSlug765928458d0d4034B7c4F5a2f0eda6c1
}

export default Components;